import { Observable } from "@apollo/client";
export default function createMulticastObservable(observable, listener) {
    const observers = new Set();
    const pastEvents = new Array();
    const subscription = observable.subscribe(function multicastObservableNext(result) {
        var _listener_next;
        listener === null || listener === void 0 ? void 0 : (_listener_next = listener.next) === null || _listener_next === void 0 ? void 0 : _listener_next.call(listener, result);
        observers.forEach((observer)=>{
            observer.next(result);
        });
        pastEvents.push({
            result
        });
    }, function multicastObservableError(error) {
        var _listener_error;
        listener === null || listener === void 0 ? void 0 : (_listener_error = listener.error) === null || _listener_error === void 0 ? void 0 : _listener_error.call(listener, error);
        observers.forEach((observer)=>{
            observer.error(error);
        });
        pastEvents.push({
            error
        });
    }, function multicastObservableComplete() {
        var _listener_complete;
        listener === null || listener === void 0 ? void 0 : (_listener_complete = listener.complete) === null || _listener_complete === void 0 ? void 0 : _listener_complete.call(listener);
        observers.forEach((observer)=>{
            observer.complete();
        });
        pastEvents.push({
            complete: true
        });
    });
    return new Observable((observer)=>{
        observers.add(observer);
        for (const event of pastEvents){
            if ('result' in event) {
                observer.next(event.result);
            } else if ('complete' in event && event.complete) {
                // Propagating previous calls to complete is important as
                // we rely on it to mark the prefetch as usable and not
                // discard it.
                observer.complete();
            } else if ('error' in event) {
                observer.error(event.error);
            }
        }
        return function multicastObservableUnsubscribe() {
            observers.delete(observer);
            if (observers.size === 0) {
                var _listener_unsubscribe;
                listener === null || listener === void 0 ? void 0 : (_listener_unsubscribe = listener.unsubscribe) === null || _listener_unsubscribe === void 0 ? void 0 : _listener_unsubscribe.call(listener);
                subscription.unsubscribe();
            }
        };
    });
}

//# sourceMappingURL=createMulticastObservable.js.map